import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d228238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "lh30 c333" }, "欢迎来到启航就业平台", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c999 fz12" }, "找工作，找人才就上启航", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c333 fz16 fbold pl40" }, "我要找工作", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c333 fz16 fbold pl40" }, "我要找人才", -1))
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisibleTF,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisibleTF) = $event)),
      width: "24%",
      "close-on-click-modal": false,
      "show-close": false,
      "close-on-press-escape": false,
      "destroy-on-close": false,
      onClose: _ctx.closeHandler
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          class: "popBtn relative mt20 pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goFindHandler('job')))
        }, [
          _hoisted_4,
          _createElementVNode("img", {
            style: {"width":"86px"},
            class: "img1",
            src: require('@/assets/Popup/people.png').default
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", {
          class: "popBtn relative mt30 pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goFindHandler('people')))
        }, [
          _hoisted_6,
          _createElementVNode("img", {
            style: {"width":"94px"},
            src: require('@/assets/Popup/job.png').default
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", {
          class: "flex justify_center mt30",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goFindHandler('looks')))
        }, [
          _createElementVNode("span", {
            class: "lh30 c2577E3 pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeHandler && _ctx.closeHandler(...args)))
          }, "先逛一逛")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}